import ReviewItem, { ReviewItemProps } from './ReviewItem'

export default ReviewItem

export { ReviewItemProps, ReviewItem }
